import { useMemo } from 'react';
import { benefitApi } from '../services/benefitApi';
import { normalizeBenefitsDocument } from '../utils/benefitMigrationDocument';
export function selectLegacyBenefitsContract(contracts, identity) {
    const matches = contracts.filter(contract => contract.id === identity.legacyContractId &&
        normalizeBenefitsDocument(contract.document) === normalizeBenefitsDocument(identity.document));
    return matches.length === 1 ? matches[0] : null;
}
export function useLegacyBenefitsContract(identity) {
    const query = benefitApi.endpoints.getContractsByOrganization.useQuery({ organizationId: identity.organizationId }, { skip: !identity.organizationId || !identity.legacyContractId, refetchOnMountOrArgChange: true });
    const contract = useMemo(() => selectLegacyBenefitsContract(query.currentData?.result ?? [], identity), [query.currentData, identity]);
    return {
        contract,
        isLoading: !query.currentData && !query.isError,
        isError: query.isError || Boolean(query.currentData && !contract),
        refetch: query.refetch,
    };
}
